export default __webpack_public_path__ + "static/media/clairefontaine14.26047200.jpg";